import { render } from "./DefaultImportScriptForm.vue?vue&type=template&id=0d423972&scoped=true"
import script from "./DefaultImportScriptForm.vue?vue&type=script&lang=js"
export * from "./DefaultImportScriptForm.vue?vue&type=script&lang=js"

import "./DefaultImportScriptForm.vue?vue&type=style&index=0&id=0d423972&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d423972"]])

export default __exports__